import { create } from "zustand";
import {
  fetchArticlesApi,
  changeHaokanApi,
  changeGuanwangApi,
  hiddenArticlesApi,
  deleteArticlesApi,
  userViewsApi,
  fetchEvaluatesApi,
} from "../apis";
import { formatArticles } from "../adapter/formatHomeData";
import { showToast, Notify } from "../components/index";

const homeStore: any = create((set: any, get: any) => ({
  homeList: [],
  homeLoading: false,
  homePagination: {
    page: 1,
    per: 10,
    hasNextPage: false,
    totalCount: 10,
  },
  addCase: false, //添加案例弹窗
  successShow: false, //提交成功弹窗
  editInfo: false, //编辑内容弹窗
  sureDelete: false, //确认删除弹窗
  setAddCase: (value: boolean) => {
    set(() => ({ addCase: value }));
  },
  setSuccessShow: (value: boolean) => {
    set(() => ({ successShow: value }));
  },
  setEditInfo: (value: boolean) => {
    set(() => ({ editInfo: value }));
  },
  setSureDelete: (value: boolean) => {
    set(() => ({ sureDelete: value }));
  },
  reset: () => {
    set(() => ({
      homePagination: {
        totalCount: 10,
        page: 1,
        per: 10,
        hasNextPage: true,
      },
    }));
  },
  // 未登录，获取storage表态
  setReplaceList: () => {
    const localList: any = localStorage.getItem("evaluateList") || "";
    // 将字符串还原为原始数组结构
    const evaluateList = localList ? JSON.parse(localList) : [];
    if (evaluateList && evaluateList.length > 0) {
      // 创建一个以 id evaluate 为值的映射对象
      const evaluateMap: { [key: string]: string } = {};
      evaluateList.forEach((item: any) => {
        evaluateMap[item.id] = item.evaluate;
      });

      // 遍历数组 homeList，根据 id 替换 evaluate
      const list: any = get().homeList.map((item: any) => {
        if (evaluateMap[item.id]) {
          return { ...item, evaluate: evaluateMap[item.id] }; // 如果存在对应的 id，则替换 evaluate
        }
        return item; // 如果没有对应的 id，保持原样
      });
      set({
        homeList: list,
      });
    }
  },
  // 获取列表
  fetchHomeList: async (isNext?: boolean) => {
    set({ homeLoading: true }); // 设置加载状态
    // 连续加载3页数据
    // for (let i = 0; i < 3; i++) {
    const page = get().homePagination.page;
    const params = {
      per: 30,
      page,
    };
    try {
      const res: any = await fetchArticlesApi(params);
      const { articles, currentPage, hasNextPage, totalCount } = res;
      const data = articles ? formatArticles(articles) : [];
      set((state: any) => ({
        homeList: isNext ? [...state.homeList, ...data] : data,
        homePagination: {
          page: currentPage + 1,
          per: state.homePagination.per || 30,
          hasNextPage,
          totalCount,
        },
        homeLoading: false,
      }));
      // 没有更多数据，则跳出循环
      // if (!hasNextPage) {
      //   break;
      // }
    } catch (err: any) {
      set({ homeLoading: false, error: err.message });
    }
    // }
  },
  // 登录后，将cookie发送给接口，由接口同步至homeList
  fetchEvaluates: async () => {
    // 从 localStorage 中获取字符串
    const localList: any = localStorage.getItem("evaluateList") || "";
    // 将字符串还原为原始数组结构
    const evaluateList = localList ? JSON.parse(localList) : [];
    if (evaluateList && evaluateList.length > 0) {
      try {
        await fetchEvaluatesApi({ articles: evaluateList });
        // 登录成功后，再存一次新的evaluateList
        const newList = get().homeList.map((item: any) => ({
          id: item.id,
          evaluate: item.evaluate,
        }));
        localStorage.setItem("evaluateList", JSON.stringify(newList));
      } catch (err: any) {
        if (err.msg) {
          Notify.error({
            message: err.msg,
            className: "notify-not-description",
            duration: 3,
          });
        }
      }
    }
  },
  // 表态
  fetchEvaluate: async (id: string, type: string) => {
    try {
      const res: any = await (type === "haokan"
        ? changeHaokanApi(id)
        : changeGuanwangApi(id));
      set((state: any) => ({
        homeList: state.homeList.map((item: any) =>
          item.id === id
            ? {
                ...item,
                evaluate: res.evaluate,
              }
            : item
        ),
      }));
    } catch (err: any) {
      if (err.msg) {
        Notify.error({
          message: err.msg,
          className: "notify-not-description",
          duration: 3,
        });
      }
    }
  },
  // 未登录，处理表态数据，存储storage
  handleEvaluate: (id: string, evaluateName: string, countName: string) => {
    set((state: any) => ({
      homeList: state.homeList.map((item: any) =>
        item.id === id
          ? {
              ...item,
              evaluate: {
                ...item.evaluate,
                [evaluateName]: !item.evaluate[evaluateName],
                [countName]: item.evaluate[evaluateName]
                  ? Number(item.evaluate[countName]) - 1
                  : Number(item.evaluate[countName]) + 1,
              },
            }
          : item
      ),
    }));
    // 存储storage
    const newList = get().homeList;
    const evaluateList = newList.map((item: any) => ({
      id: item.id,
      evaluate: item.evaluate,
    }));
    localStorage.setItem("evaluateList", JSON.stringify(evaluateList));
  },
  // 编辑信息后，处理数据
  handleInfo: async (obj: any) => {
    set((state: any) => ({
      homeList: state.homeList.map((item: any) =>
        item.id === obj.id
          ? {
              ...item,
              title: obj.title,
              summary: obj.summary,
              domainName: obj.domainName,
              originalLink: obj.originalLink,
              updatedAt: obj.updatedAt,
            }
          : item
      ),
    }));
  },
  // 显示/隐藏
  fetchDisabled: async (id: string, hide: boolean) => {
    try {
      await hiddenArticlesApi(id);
      showToast(hide ? "已取消隐藏" : "隐藏成功");
      set((state: any) => ({
        homeList: state.homeList.map((item: any) =>
          item.id === id
            ? {
                ...item,
                disabled: !hide,
              }
            : item
        ),
      }));
    } catch (err: any) {
      if (err.msg) {
        Notify.error({
          message: err.msg,
          className: "notify-not-description",
          duration: 3,
        });
      }
    }
  },
  // 删除
  fetchDelete: async (id: string) => {
    try {
      await deleteArticlesApi(id);
      showToast("删除成功");
      const list = get().homeList;
      const index: any = list.findIndex((item: any) => item.id === id);
      if (index !== -1) {
        list.splice(index, 1);
      }
      set(() => ({
        homeList: list,
      }));
    } catch (err: any) {
      if (err.msg) {
        Notify.error({
          message: err.msg,
          className: "notify-not-description",
          duration: 3,
        });
      }
    }
  },
  // 统计人数
  fetchViewsCount: async (id: string) => {
    try {
      await userViewsApi(id);
      set((state: any) => ({
        homeList: state.homeList.map((item: any) =>
          item.id === id
            ? {
                ...item,
                userViewsCount: Number(item.userViewsCount) + 1,
              }
            : item
        ),
      }));
    } catch (err: any) {
      if (err.msg) {
        Notify.error({
          message: err.msg,
          className: "notify-not-description",
          duration: 3,
        });
      }
    }
  },
}));

export default homeStore;
